<template>
  <div class="table-no-records">
    <div>
      <Component :is="{ ...props.icon }" />
      <div>
        <p class="header">{{ props.headerText }}</p>
        <template v-if="props.hasPermissions">
          <p
            v-if="props.detailsText"
            class="details">
            {{ props.detailsText }}
          </p>
          <slot name="extra-content"></slot>
          <template v-if="props.actionText && props.actionHandler">
            <button
              :disabled="!props.isActionEnabled"
              :name="props.buttonName || 'noRecordsAction'"
              :class="['btn', isPrimary ? 'btn-primary' : 'btn-default', 'mt-4']"
              @click="props.actionHandler">
              {{ props.actionText }}
            </button>
          </template>
        </template>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import type { Component } from 'vue';

  // #region Props

  interface INoRecordsTableProps {
    icon: Component;
    headerText: string;
    detailsText?: string;
    buttonName?: string;
    actionText?: string;
    isPrimary?: boolean;
    isActionEnabled?: boolean;
    hasPermissions?: boolean;
    actionHandler?: () => void;
  }

  const props = withDefaults(defineProps<INoRecordsTableProps>(), {
    detailsText: null,
    buttonName: null,
    actionText: null,
    isPrimary: true,
    isActionEnabled: true,
    hasPermissions: true,
    actionHandler: null,
  });

  // #endregion
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
  @use '@/styles/variables' as *;
  .icon-slot {
    margin-left: 0;
  }
</style>
